<template>
    <div id="userbox-dropdown">
        <div class="overlay" v-if="showDropdown" @click="onOutsideClick"/>
        <button v-b-tooltip.hover title="Profile" @click="showDropdown = !showDropdown" class="profile-pic-btn">
            <img :src="userPic" alt="">
        </button>
        <div v-if="showDropdown" id="userBox">
            <div class="profile-info">
                 <div data-name="my-profile"  class="li-item">
                    <Icon icon="profile-dropdown"/>
                    <button id="my-profile" @click="showDrawer" class="pl-0">
                        <p>My Profile</p>
                    </button>
                </div>
                <div data-name="my-membership"  class="li-item" v-if="!isEcommercePlatform && !user.isAdmin">
                    <Icon icon="crown" />
                    <router-link 
                        id="my-membership"
                        @click.native = "trackEvent('My Membership')"
                        to="/dashboard/membership">
                        My Membership
                    </router-link>
                </div>
            </div>
            <div data-name="section" v-if="!isEcommercePlatform">
                <p data-name="my-camps">
                    my campaigns
                </p>
            </div>
            <div v-if="!isEcommercePlatform">
                <ul>
                    <li class="li-item">
                        <Icon icon="publish-icon"/>
                        <router-link 
                            @click.native="trackEvent('Published')"
                            id="my-publishes"
                            to="/dashboard/campaigns/publish">
                            Published
                        </router-link>
                    </li>
                    <li class="li-item">
                        <Icon icon="draft-icon"/>
                        <router-link 
                            @click.native="trackEvent('Drafts')"
                            id="my-drafts"
                            to="/dashboard/campaigns/drafts">
                            Drafts
                        </router-link>
                    </li>
                    <li class="li-item">
                        <Icon icon="archives-icon"/>
                        <router-link 
                            @click.native="trackEvent('Archive')"
                            id="my-archives"
                            to="/dashboard/campaigns/archives">
                            Archive
                        </router-link>
                    </li>
                </ul>
                <div  class="li-item" data-name="favorite">
                    <Icon icon="favorite-icon"/>
                    <router-link 
                        @click.native="trackEvent('Favorites')"
                        id="my-favorites"
                        to="/dashboard/campaigns/favorite">
                        Favorites
                    </router-link>
                </div>
                <ul style="border: 0 !important; margin-top: 16px">
                    <li class="li-item">
                        <Icon icon="help-icon"/>
                        <a 
                            @click="toCrosspromHelp" 
                            href="https://help.crossprom.com/" 
                            id="help-dropdown"
                            target="_blank">
                            Help
                        </a>
                    </li>
                    <li class="li-item">
                        <Icon icon="logout-icon"/>
                        <p id="sign-out" @click="logout">
                            Sign Out
                        </p>
                    </li>
                </ul>
            </div>
            <div v-else>
                <ul>
                    <li class="li-item" style="padding-top: 16px; padding-bottom: 16px">
                        <Icon icon="publish-icon"/>
                        <a
                            @click="toMyShops('My Shops')"
                            id="my-shops"
                        >
                            My Shops
                        </a>
                    </li>
                </ul>
                <ul style="border: 0 !important; margin-top: 16px">
                    <li class="li-item">
                        <Icon icon="logout-icon"/>
                        <p id="sign-out" @click="logout">
                            Sign Out
                        </p>
                    </li>
                </ul>
            </div>
        </div>
        <a-drawer
            placement="right"
            :closable="false"
            :visible="drawerVisible"
            @close="onClose">
                <MyProfileDrawer @close="onClose"/>
        </a-drawer>

    </div>
</template>

<script>
import {mapState, mapGetters} from 'vuex'
import Icon from '@/components/Theme/Icon'
import MyProfileDrawer from './MyProfileDrawer'
import {
    PROFILE_PIC_PLACEHOLDER_MINI_BLUE,
    PROFILE_PIC_PLACEHOLDER,
} from "../../../constants";
import { useShops, useUserId } from '../../../core/hooks'
import { message } from 'ant-design-vue'
export default {
    name: "UserDropdwon",
    components: {
        MyProfileDrawer,
        Icon
    },
    computed: {
        ...mapState([
            'user'
        ]),
        ...mapGetters(['isEcommercePlatform']),
        userPic() {
            return this.user && this.user.user_img || PROFILE_PIC_PLACEHOLDER;
        },
    },
    data() {
        return {
            drawerVisible: false,
            PROFILE_PIC_PLACEHOLDER_MINI_BLUE,
            PROFILE_PIC_PLACEHOLDER,
            showDropdown: false
        }
    },
    watch: {
        $route (to, from){
            this.showDropdown = false
        },
    },
    methods: {
        onOutsideClick() {
            this.showDropdown = false
        },
        onClose() {
            this.drawerVisible = false;
        },
        showDrawer() {
            this.$ga.event('User Dropdown', 'Item Click', 'ItemName', 'My Profile')
            this.$sendMixpanelEvent('User Dropdown Item Clicked', {
                'Item Name': 'My Profile'
            })
            this.showDropdown = false
            this.drawerVisible = true;
        },
        logout(){
            this.$store.dispatch('logout')
            this.$sendMixpanelEvent('Sign Out')
            this.$ga.event('Auth','Sign Out')
            this.$resetMixpanel()
        },
        trackEvent(itemName){
            this.$ga.event('User Dropdown', 'Item Click', 'ItemName', itemName)
            this.$sendMixpanelEvent('User Dropdown Item Clicked', {
                'Item Name': itemName
            })
        },
        toCrosspromHelp(){
            this.$ga.event('Help', 'Click', `
                LoggedIn: true,
                Location: User Dropdown
            `)
            this.$sendMixpanelEvent('Help Clicked', {
                'Logged In': true,
                'Link Location': 'User Dropdown'
            });
        },
        async toMyShops(eventName) {
            this.trackEvent(eventName)
            this.$router.push('/my-shops').catch(() => {})
        }
    }
}
</script>

<style scoped lang="scss">
@import '../../../assets/scss/variables.scss'; 
div#userbox-dropdown {
    div.overlay {
        position: fixed;
        width: 100%;
        height: 100%;
        background: transparent;
        z-index: 999;
        left: 0;
        top: 0;
        overflow: hidden;
    }
}
button {
    &.profile-pic-btn {
        padding-left: 20px;
        img {
            width: 40px;
            height: 40px;
            border-radius: 50%;
        }
    }
}
div#userBox {
    width: 230px;
    background: #FFFFFF;
    box-shadow: 0px 0px 75px rgba(0, 0, 0, 0.17);
    border-radius: 10px;
    position: absolute;
    top: 44px;
    right: 0;
    z-index: 1010;
    
    p, a {
        font-size: $p3;
        color: $c3;
        margin: 0;
        margin-left: 14px;
    }

    .li-item {
        img {
            filter: grayscale(100%) invert(1.1);
        }
        &:hover {
            p:not([data-name="my-camps"]),a {
                color: $c1;
            }
            img {
                filter: none;
                
            }
        }
    }

    [data-name="my-membership"] {
        img {
            width: 15px;
            margin-right: 3px;
            opacity:0.6;
        }
        &:hover {
            img {
                opacity: 1;
            }
        } 
        a {
            margin-left: 8px;
        }
    } 
    
    div[data-name="my-profile"], div[data-name="my-membership"]  {
        display: flex;
        align-items: center;
        padding-left: 24px;
        padding-top: 16px;
    }

    .profile-info {
        border-bottom: 1px solid $c10;
        padding-bottom: 16px;
    }

    div[data-name="section"] {
        padding-top: 16px;
        padding-bottom: 16px;
        padding-left: 8px;
        p {
            font-size: $p4;
            color: $p3;
            text-transform: uppercase;
        }
    }
    ul {
        margin: 0;
        padding: 0;
        padding-left: 24px;
        border-bottom: 1px solid $c10;
        
        li {
            display: flex;
            align-items: center;
            padding-bottom: 24px;
            cursor: pointer;
        }
    }
    div[data-name="favorite"] {
        padding-left: 24px;
        padding-top: 16px;
        padding-bottom: 16px;
        border-bottom: 1px solid $c10;
    }
}

</style>